import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=47d5eb97&scoped=true&"
import script from "./CreateGame.vue?vue&type=script&lang=js&"
export * from "./CreateGame.vue?vue&type=script&lang=js&"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=47d5eb97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5eb97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
